export const initialState = {
  isFetching: false,
  isFetched: false,
  data: {
    easyBalance: 0,
    availableWithdrawMoney: 0
  },
  success: false,
  error: false
}

export const ACTION_TYPES = {
  FINANCIAL_POSITION_REQUEST: 'FINANCIAL_POSITION_REQUEST',
  FINANCIAL_POSITION_SUCCESS: 'FINANCIAL_POSITION_SUCCESS',
  FINANCIAL_POSITION_ERROR: 'FINANCIAL_POSITION_ERROR'
}

export const getFinancialPosition = (payload = {}) => ({
  type: ACTION_TYPES.FINANCIAL_POSITION_REQUEST,
  payload
})

const financialPosition = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.FINANCIAL_POSITION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.FINANCIAL_POSITION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        success: true,
        error: false,
        data: {
          ...state.data,
          availableWithdrawMoney: payload.availableWithdrawMoney,
          easyBalance: payload.availableBalance
        }
      }
    case ACTION_TYPES.FINANCIAL_POSITION_ERROR:
      return {
        ...state,
        error: true,
        success: false,
        isFetching: false,
        isFetched: true
      }
    default:
      return state
  }
}

export default financialPosition
